var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerAirportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#e3e3e3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m399.31-158.08-83.62-157.84-158.61-84.39 43.3-43.07 138.08 23.46 122-122L160.38-670l55.54-55.23 365 62.61 124.77-125.53Q722.54-805 746.92-805q24.39 0 41.23 16.85Q805-771.31 805-747.04t-16.85 41.12l-125.77 125L725-216.15l-55.77 55.77-127.54-300.08-122 122 22.93 137.08-43.31 43.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerAirportIcon);
export default __webpack_public_path__ + "static/media/marker-airport-icon.6667d1e13c4230257bcb69dede659702.svg";
export { ForwardRef as ReactComponent };